import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b331430c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, [
  /*#__PURE__*/_createElementVNode("div", null, "操作提示："),
  /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"5px","font-size":"14px"} }, "平台管理用户信息。"),
  /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"5px","font-size":"14px"} }, "平台可对用户进行编辑，账户调整，等级调整和资料查看等操作。 ")
], -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("正常")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("禁用")
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 4 }
const _hoisted_9 = { key: 5 }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("禁用")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 上传 ")
const _hoisted_13 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_icon = _resolveComponent("a-icon")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_card, { title: "用户列表" }, {
      default: _withCtx(() => [
        _hoisted_1,
        _createVNode(_component_a_form, {
          name: "basic",
          autocomplete: "off"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "姓名" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.searches.keyword,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searches.keyword) = $event)),
                  placeholder: "请输入姓名",
                  style: {"width":"200px"}
                }, null, 8, ["value"]),
                _createVNode(_component_a_button, {
                  style: {"margin-left":"10px"},
                  type: "primary",
                  onClick: $setup.onSearch
                }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_a_button, {
                  style: {"margin-left":"10px"},
                  onClick: $setup.onReset
                }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_table, {
          dataSource: _ctx.list,
          columns: $setup.columns,
          bordered: "",
          pagination: $setup.pagination,
          onChange: $setup.handleTableChange,
          style: {"margin-top":"10px"}
        }, {
          bodyCell: _withCtx(({ column, record }) => [
            (column.key === 'disable')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (record.disable== 0)
                    ? (_openBlock(), _createBlock(_component_a_tag, {
                        key: 0,
                        color: "green"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_4
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (record.disable== 1)
                    ? (_openBlock(), _createBlock(_component_a_tag, {
                        key: 1,
                        color: "#f50"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            (column.key === 'avatar')
              ? (_openBlock(), _createBlock(_component_a_image, {
                  key: 1,
                  src: record.avatar,
                  style: {"width":"50px"}
                }, null, 8, ["src"]))
              : _createCommentVNode("", true),
            (column.key === 'create_time')
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(record.create_time.slice(0,10)), 1))
              : _createCommentVNode("", true),
            (column.key === 'inviter')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  (record.inviter!==null)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(record.inviter.nickname), 1))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            (column.key === 'update_time')
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(record.update_time.slice(0,10)), 1))
              : _createCommentVNode("", true),
            (column.key === 'action')
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createVNode(_component_a_button, {
                    size: "small",
                    onClick: ($event: any) => ($setup.edit(record))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_a_popconfirm, {
                    title: "是否禁用该类目?",
                    "ok-text": "禁用",
                    "cancel-text": "不禁用",
                    onCancel: ($event: any) => ($setup.onDel(record,0)),
                    onConfirm: ($event: any) => ($setup.onDel(record,1))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        size: "small",
                        style: {"margin":"5px"}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_11
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onCancel", "onConfirm"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["dataSource", "columns", "pagination", "onChange"])
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.visible) = $event)),
      title: _ctx.title,
      onOk: _cache[7] || (_cache[7] = ($event: any) => ($setup.onSubmit('formRef')))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          ref: "formRef",
          rules: $setup.rules,
          model: _ctx.formState,
          name: "basic",
          "label-col": { span: 4 },
          "wrapper-col": { span: 20 },
          autocomplete: "off"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "会员昵称",
              name: "nickname"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formState.nickname,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.nickname) = $event)),
                  placeholder: "请输入会员昵称"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "头像",
              name: "avatar"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_upload, {
                  name: "file",
                  "file-list": _ctx.fileList,
                  class: "avatar-uploader",
                  headers: $setup.uploadHeaders,
                  action: $setup.uploadAction,
                  data: $setup.uploadFormData,
                  onChange: $setup.handleChange
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createVNode(_component_a_button, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_icon, { type: "upload" }),
                          _hoisted_12
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }, 8, ["file-list", "headers", "action", "data", "onChange"]),
                (_ctx.formState.avatar!== '' )
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.formState.avatar,
                      style: {"width":"50px","margin-top":"10px"}
                    }, null, 8, _hoisted_13))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "手机号",
              name: "mobile"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formState.mobile,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formState.mobile) = $event)),
                  placeholder: "请输入手机号",
                  disabled: ""
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "生日",
              name: "birthday"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_date_picker, {
                  value: _ctx.formState.birthday,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formState.birthday) = $event)),
                  "value-format": "YYYY-MM-DD",
                  placeholder: "请选择生日",
                  style: {"width":"100%"}
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "备注",
              name: "remark"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formState.remark,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formState.remark) = $event)),
                  placeholder: "请输入备注"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "会员标签",
              name: "select"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  ref: "select",
                  mode: "multiple",
                  value: _ctx.formState.select,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formState.select) = $event)),
                  style: {"width":"100%"},
                  placeholder: "请选择会员标签"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tagList, (item, index) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: index,
                        value: item.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["rules", "model"])
      ]),
      _: 1
    }, 8, ["visible", "title"])
  ]))
}